import config from '@/config/prod.env';
import header from '@/helper/header';
import common from '@/helper/common';

const mainUrl = `${process.env.VUE_APP_API_URL}/Workspace`;

export default {  
    getAll: async () => {
        const requestOptions = {
            method: 'GET',
            headers: await header.authHeaderWithToken(),
        };
    
        let rs = await fetch(`${mainUrl}/GetAll`, requestOptions);
        return await common.handleResponse(rs);
    },
    
    getAllPaging: async (params) => {
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "currentPage": params.currentPage,
                "perPage": (params.perPage)? params.perPage : config.DEFAULT_LIMIT,
                "sortBy": (params.sortBy)? params.sortBy: "0",
                "orderDesc": params.sortDesc,
                "searchkey": (params.searchKey)? params.searchKey: ""
            })
        };
    
        let rs = await fetch(`${mainUrl}/GetAllPaging`, requestOptions);
        return await common.handleResponse(rs);
    },

    getById: async (id) => {
        const requestOptions = {
            method: 'GET',
            headers: await header.authHeaderWithToken(),
        };
    
        let rs = await fetch(`${mainUrl}/GetById?id=${id}`, requestOptions);
        return await common.handleResponse(rs);
    },
    
    // getByUserId: async (userId) => {
    //     const requestOptions = {
    //         method: 'GET',
    //         headers: await header.authHeaderWithToken(),
    //     };
    
    //     let rs = await fetch(`${mainUrl}/GetByUserId?userId=${userId}`, requestOptions);
    //     return await common.handleResponse(rs);
    // },
    
    getByRoleIds: async (roleIds) => {
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify(roleIds)
        };
    
        let rs = await fetch(`${mainUrl}/GetByRoleIds`, requestOptions);
        return await common.handleResponse(rs);
    },
    
    create: async (workspace) => {
        let user = JSON.parse(localStorage.getItem('login_info'));
        var requestOptions = {
            method: 'POST',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify({
                "operatingCenterName": workspace.operatingCenterName,
                "operatingCenterLogo": workspace.operatingCenterLogo,
                "workspaceName": workspace.workspaceName,
                "workspaceType": workspace.workspaceType,
                "azureToken": user.pbiAccessToken.access_token,
            }),
        };
    
        let rs = await fetch(`${mainUrl}/Create`, requestOptions);
        return await common.handleResponse(rs);
    },

    update: async (workspace) => {
        const requestOptions = {
            method: 'PUT',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify({
                "id": workspace.id,
                "operatingCenterName": workspace.operatingCenterName,
                "operatingCenterLogo": workspace.operatingCenterLogo,
                "workspaceName": workspace.workspaceName,
                "workspaceType": workspace.workspaceType,
                "isUsePBIHome": workspace.isUsePBIHome,
                "reportId": workspace.reportId
            })
        };
    
        let rs = await fetch(`${mainUrl}/Update`, requestOptions);
        return await common.handleResponse(rs);
    },
    
    delete: async (id) => {
        let user = JSON.parse(localStorage.getItem('login_info'));
        const requestOptions = {
            method: 'DELETE',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "id": id,
                "azureToken": user.pbiAccessToken.access_token
            })
        };
    
        let rs = await fetch(`${mainUrl}/HardDelete`, requestOptions);//.then(response => common.handleResponse(response));
        return await common.handleResponse(rs);
    },
}